import { faCheckCircle, faCircleXmark } from '@fortawesome/pro-solid-svg-icons'

import {
  Box, Checkbox, DashboardModuleListItem, Text,
} from '@domain-group/suit-theme'

import useAgencyPortal from '@hooks/useAgencyPortal'

import type { AgencyPortalModel } from '@models/types'

interface AgencyPortalListItemProps {
  agencyPortal: Partial<AgencyPortalModel>,
}
const AgencyPortalListItem = (props: AgencyPortalListItemProps) => {
  const { agencyPortal } = props

  const {
    agencyPortal: {
      authentication_token, force_xml_agency, identity_code,
    },
    callbacks: {
      createOrEditAgencyPortal,
    },
    portal: {
      title,
    },
  } = useAgencyPortal(agencyPortal)

  return (
    <DashboardModuleListItem
      secondaryText={(
        <Box alignItems="center">
          <Checkbox
            boxProps={{ marginRight: 'small' }}
            checked
            color={force_xml_agency ? 'green' : 'red'}
            fontSize="xsmall"
            iconChecked={force_xml_agency ? faCheckCircle : faCircleXmark}
            iconDefault={force_xml_agency ? faCheckCircle : faCircleXmark}
          />
          <Text color="bodyFontLightColor" fontSize="xsmall">
            Force XML Agency
          </Text>
        </Box>
      )}
      onClick={() => createOrEditAgencyPortal({})}
      title={title}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>
        <Box flexDirection="column" fontSize="xsmall" textAlign="right">
          <Text variant="ellipsis">{identity_code}</Text>

          <Text color="bodyFontLightColor" marginTop="xsmall" variant="ellipsis">
            {authentication_token}
          </Text>
        </Box>
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>
    </DashboardModuleListItem>
  )
}

export default AgencyPortalListItem
